export default "__VITE_ASSET__Dagio17Z__"